import { MeterUploadRowStatus, type MeterUploadRow } from "./buildTrialRunRow";

export const MeterUploadStatus = {
  Draft: "Draft",
  PartiallyCompleted: "PartiallyCompleted",
  Completed: "Completed",
} as const;
export type MeterUploadStatusValue =
  (typeof MeterUploadStatus)[keyof typeof MeterUploadStatus];

export const computeParentStatus = (
  rows: MeterUploadRow[],
): MeterUploadStatusValue => {
  if (
    rows.length > 0 &&
    rows.every(r => r.status === MeterUploadRowStatus.Success)
  ) {
    return MeterUploadStatus.Completed;
  }
  if (rows.some(r => r.status === MeterUploadRowStatus.Success)) {
    return MeterUploadStatus.PartiallyCompleted;
  }
  return MeterUploadStatus.Draft;
};
